import React, { useRef, useState } from "react";

import productImage from "../assets/images/product_video_thumbnail.webp";
import productVideo from "/videos/maxipitch_product_video.mp4";

export default function ProductVideoSection({
    thumbnailSrc = productImage,
    // videoSrc = productVideo,
    videoSrc = "https://f003.backblazeb2.com/file/maxipitch-media/videos/maxipitch_product_video_22.mp4",
    title1 = "Build For ",
    title2 = "The Business ",
    title3 = "You Want - Not Just The One You Have",
    subtitle = "Watch a quick overview",
}) {
    const videoRef = useRef(null);
    const [started, setStarted] = useState(false);

    const handleStart = () => {
        setStarted(true);
        requestAnimationFrame(async () => {
            try {
                await videoRef.current?.play();
            } catch {
                // autoplay may be blocked; controls will still work
            }
        });
    };

    const handleBack = () => {
        const v = videoRef.current;
        if (v) {
            v.pause();
            v.currentTime = 0;
        }
        setStarted(false);
    };

    return (
        <section className="w-full py-20 max-md:py-12 max-md:pb-6">
            <div className="mx-auto max-w-6xl px-4">
                <div className="mb-6 max-md:mb-4 text-center">
                    <h2 className=" mb-3 ">
                        {title1}
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                            {" "}
                            {title2}
                        </span>
                        <span className="">
                            {" "}
                            {title3}
                        </span>
                    </h2>
                    {subtitle ? <p className="mt-6 text-gray-600 text-xl max-md:text-base">{subtitle}</p> : null}
                </div>

                {/* Gradient border wrapper */}
                <div className="rounded-3xl mt-12 max-md:mt-8 max-md:mb-4 bg-gradient-to-r from-blue-600 via-indigo-300 to-purple-200 p-[8px] shadow-[10px_20px_20px_-20px_rgba(59,130,246,0.9)]">
                    {/* Inner card */}
                    <div className="relative overflow-hidden rounded-3xl bg-slate-950">
                        {/* Aspect-ratio frame (NO plugin needed) */}
                        <div
                            className="relative w-full"
                            style={{ aspectRatio: "16 / 9" }}
                        >
                            {/* Fallback for very old browsers (keeps height) */}
                            <div className="absolute inset-0">
                                {!started ? (
                                    <>
                                        <img
                                            src={thumbnailSrc}
                                            alt="Product video thumbnail"
                                            className="block h-full w-full object-cover opacity-95"
                                            draggable={false}
                                        />

                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-black/20" />

                                        <button
                                            type="button"
                                            onClick={handleStart}
                                            className="group absolute inset-0 grid place-items-center focus:outline-none"
                                            aria-label="Play video"
                                        >
                                            <span className="grid h-20 w-20 place-items-center rounded-full bg-white/15 ring-1 ring-white/25 backdrop-blur-md transition group-hover:scale-105 group-hover:bg-white/20">
                                                <svg
                                                    width="28"
                                                    height="28"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    className="translate-x-[1px]"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M8 5v14l11-7L8 5z" fill="white" />
                                                </svg>
                                            </span>
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <video
                                            ref={videoRef}
                                            className="h-full w-full object-cover"
                                            src={videoSrc}
                                            controls
                                            playsInline
                                            controlsList="nodownload"
                                            disablePictureInPicture={false}
                                        />
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Optional padding fallback if aspect-ratio is unsupported */}
                        <div className="hidden" aria-hidden />
                    </div>
                </div>
            </div>
        </section>
    );
}
